import { DictionaryObject } from '@cawita/core-front';
import { ApiData } from '@cawita/core-front/api';
import { CwtModel } from '@shared/modules/crud';
import { Address } from './address.model';
import { Document } from './document.model';
import { Partner } from './partner.model';

@CwtModel({ name: 'place', path: '/place' })
export class Place extends ApiData {
    partner?: Partner;
    address?: Address;
    placeType?: string;
    picture?: Document;
    name?: DictionaryObject;
    description?: DictionaryObject;
    xPos?: number;
    yPos?: number;

    fieldDictionary() {
        return {
            partner: Partner,
        };
    }
}
